import { render, staticRenderFns } from "./goods-group-label.vue?vue&type=template&id=21bf84d5&scoped=true"
import script from "./goods-group-label.vue?vue&type=script&lang=js"
export * from "./goods-group-label.vue?vue&type=script&lang=js"
import style0 from "./goods-group-label.vue?vue&type=style&index=0&id=21bf84d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bf84d5",
  null
  
)

export default component.exports